<template>
    <div class="questions-bank-page">
        <v-card class="pa-1 mb-4" :class="{'bordered': pcOnly}" flat>
            <v-card-title class="d-block">
                <div class="d-flex align-center flex-wrap">

                    <v-btn icon :color="currentDirectory ? 'primary darken-1' : 'text'" :disabled="!currentDirectory" :to="currentDirectory && currentDirectory.parent_category_id ? {name: 'questions-bank-directory', params: {id: currentDirectory.parent_category_id}} : {name: 'questions-bank'}">
                        <v-icon v-if="!currentDirectory || !currentDirectory.parent_category_id">mdi-home</v-icon>
                        <v-icon v-else>mdi-folder-move{{!currentDirectory ? '-outline' : ''}}</v-icon>
                    </v-btn>

                    <v-btn :to="{name: 'questions-bank'}" exact text color="strong-text" dense style="font-size: 1.1rem" class="px-2">
                        <!-- <v-icon size="22" left>mdi-home-outline</v-icon> -->
                        بنك اﻷسئلة
                    </v-btn>

                    <template v-if="currentDirectory" >

                        <template v-for="(dir) in currentDirectory.full_path_dirs">
                            <v-icon :key="'icon' + dir.id" color="grey">mdi-chevron-left</v-icon>

                            <v-btn :to="{name: 'questions-bank-directory', params: {id: dir.id}}" exact text color="strong-text" :key="'button' + dir.id" v-ripple="dir.id !== currentDirectory.id" dense style="font-size: 1.1rem; text-transform: none; min-width: auto!important" class="px-2 strong-text--text d-flex align-center">
                                {{dir.name}}
                            </v-btn>
                        </template>
                    </template>
                </div>

                <v-divider class="mt-3"></v-divider>
            </v-card-title>
            <v-card-text :class="{'px-0': phoneOnly}">
                    
                    <form @submit.prevent="filter" 
                    v-if="(questionsItems && questionsItems.length) || filterMode"
                        class="d-flex flex-column flex-lg-row px-4"
                        >
                        <v-text-field v-model.number="pageNumber" type="number" min="1" :solo="phoneOnly" :flat="phoneOnly" label="فلترة باستخدام رقم الصفحة" placeholder="فلترة باستخدام رقم الصفحة" :prepend-inner-icon="pcOnly ? 'mdi-filter' : ''" :append-icon="phoneOnly ? 'mdi-filter' : ''" :outlined="pcOnly" :dense="pcOnly" clearable class="mb-lg-4 mb-3 me-lg-3" :class="{'course-input': phoneOnly}" hide-details ></v-text-field>
                        <v-text-field v-model.number="questionNumber" type="number" min="1" :solo="phoneOnly" :flat="phoneOnly" label="فلترة باستخدام رقم السؤال" placeholder="فلترة باستخدام رقم السؤال" :prepend-inner-icon="pcOnly ? 'mdi-filter' : ''" :append-icon="phoneOnly ? 'mdi-filter' : ''" :outlined="pcOnly" :dense="pcOnly" clearable class="mb-lg-4 mb-3 me-lg-3" :class="{'course-input': phoneOnly}" hide-details ></v-text-field>
                
                        <v-btn type="submit" color="primary" class="mb-lg-4 mb-3 me-lg-3" :small="phoneOnly">فلترة</v-btn>
                        <v-btn text  @click="resetFilters" :disabled="!pageNumber && !questionNumber" :small="phoneOnly">
                            <v-icon left>mdi-filter-remove-outline</v-icon>
                            إلغاء الفلترة
                        </v-btn>
                    </form>

                <div v-if="(directories && directories.length) || (questionsItems && questionsItems.length)">
                    <v-list v-if="directories && directories.length" two-line class="pa-0 mb-3">
                        <v-subheader style="height: auto" class="mb-1">المجلدات</v-subheader>
                        <v-list-item v-for="dir in directories" :key="dir.id" v-ripple="phoneOnly" :to="{name: 'questions-bank-directory', params: {id: dir.id}}" class="directories-item py-1">
                            <v-list-item-icon>
                                <v-icon :color="dir.type === 'default' ? 'blue darken-1' : (dir.type && dir.type.search('teacher') !== -1 ? 'teal' : 'blue-grey lighten-1')">mdi-folder</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{dir.name}}</v-list-item-title>
                                <v-list-item-subtitle>
                                    <div v-if="dir.child_categories_count || dir.questions_count" class="d-flex">
                                        <span v-if="dir.child_categories_count" class="me-3">
                                            <v-icon class="me-1" size="14">mdi-folder-multiple-outline</v-icon>
                                            <span>{{dir.child_categories_count}} مجلدات</span>
                                        </span>
                                        <span v-if="dir.questions_count">
                                            <v-icon class="me-1" size="14">mdi-file-question-outline</v-icon>
                                            <span>{{dir.questions_count}} أسئلة</span>
                                        </span>
                                    </div>
                                    <span v-else>مجلد فارغ</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>

                    <v-list v-if="questionsItems && questionsItems.length" two-line class="pa-0 mb-3">
                        <v-subheader style="height: auto" class="mb-1">اﻷسئلة</v-subheader>
                        <v-list-item v-for="question in questionsItems" :key="question.id" v-ripple="phoneOnly" @click="questionDetailsDialog = true; questionDetails = question" class="questions-item">
                            <v-list-item-icon :class="{'me-3': phoneOnly}">
                                <v-icon size="28" color="primary">mdi-file-question-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span v-if="question.text">{{question.text}}</span>
                                    <span v-else-if="question.image_url"><strong class="details-text">[صورة]</strong></span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                        #{{question.id}}
                                    </v-chip>
                                    <v-chip v-if="question.page_number" color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                        <v-icon class="me-1">mdi-file-outline</v-icon>
                                        {{question.page_number}}
                                    </v-chip>
                                    <v-chip v-if="question.question_number" color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                        س {{question.question_number}}
                                    </v-chip>

                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-btn v-if="questionsNext" color="primary" block text class="mt-3" :loading="loadingMoreQuestions" :disabled="loadingMoreQuestions" @click="loadMoreQuestions">
                        تحميل المزيد من الأسئلة
                    </v-btn>

                </div>
                <div v-else class="py-2">
                    <v-alert text type="info" color="blue-grey darken-1">
                        <b>التصنيف فارغ: </b> هذا التصنيف لا يحتوي على أي أسئلة أو تصنيفات فرعية
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>


        <div class="actions">
            <!-- <action-dialog v-model="updateMaxTokensDialog" max-width="380" action="put" :url="`/users/${id}`" :data="{max_tokens: maxTokens}" title="تعديل عدد اﻷجهزة" subtitle="تعديل عدد الأجهزة المسموح لها بالدخول إلى هذا الحساب" button-text="حفظ" button-color="primary" @sync="sync" @reset="maxTokens = ''">
                <v-text-field v-model="maxTokens" type="number" :min="1" label="الحد اﻷقصى للأجهزة"></v-text-field>
            </action-dialog> -->

            
            <question-details v-model="questionDetailsDialog" :question-details="questionDetails" />
        </div>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import QuestionDetails from './questions-details'

export default {
    components: {
        QuestionDetails,
    },
    props: {
        categories: {},
        questions: {},
        current_directory: {},
        filterMode: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            page_url: '/questions-bank/questions/directories',

            renameDialog: false,
            editedDirectory: {
                id: null,
                name: '',
            },

            deleteDirectoryDialog: false,
            deleteDirectory: null,

            deleteQuestionDialog: false,
            deleteQuestion: null,

            questionDetailsDialog: false,
            questionDetails: null,

            currentDirectory: null,
            directories: null,

            questionsItems: null,
            questionsNext: null,
            loadingMoreQuestions: false,

            pageNumber: null,
            questionNumber: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {

        categories(categories){
            this.directories = categories && categories.data ? categories.data : [];
        },
        questions(questions){
            this.questionsItems = questions && questions.data ? questions.data : [];
        },
        current_directory(current_directory){
            this.currentDirectory = current_directory ? current_directory.data || current_directory: null;
        },

        filterMode(){
            if (!this.filterMode){
                this.pageNumber = null;
                this.questionNumber = null;
            }
        }
    },
    methods: {
        ...GlobalMethods,
        filter(){
            this.$emit('filter', this.pageNumber, this.questionNumber);
        },
        resetFilters(){
            this.pageNumber = null;
            this.questionNumber = null
            this.$emit('filter', this.pageNumber, this.questionNumber);
        },
        syncDirectory(newItem){
            this.directories = this.directories.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        addDirectory(newItem){
            this.directories.push(newItem);
        },
        deleteDirectoryItem(id){
            this.directories = this.directories.filter(item=>{
                return item.id !== id;
            });
        },
        deleteQuestionItem(id){
            this.questionsItems = this.questionsItems.filter(item=>{
                return item.id !== id;
            });
        },
        textMax(text, length){
            return text ? (text.length > length ? text.slice(0, length) + ' ...' : text) : '';
        },
        
        loadMoreQuestions(){
            if (!this.loadingMoreQuestions && this.questionsNext){
                this.loadingMoreQuestions = true;

                this.$store.dispatch('fastGetAction', {url: this.questionsNext}).then(response=>{
                    this.loadingMoreQuestions = false;
                    const data = response.data;
                    if (data.questions.data){
                        this.questionsItems.push(...data.questions.data);
                    }
                    this.questionsNext = data.questions.links.next;
                }).catch(e=>{
                    this.loadingMoreQuestions = false;
                });

            }
        },
    },
    created(){
        this.currentDirectory = this.current_directory ? this.current_directory.data || this.current_directory : null;
        if (this.categories){
            this.directories = this.categories.data || [];
        }else{
            this.directories = [];
        }
        
        if (this.questions){
            this.questionsItems = this.questions.data || [];
            this.questionsNext = this.questions.links.next;
        }else{
            this.questionsItems = [];
        }
    }
}

</script>
<style lang="scss" scoped>
.v-list--two-line{
    .directories-item, .questions-item{
        &.v-list-item .v-list-item__icon{
            margin-bottom: 16px!important;
        }
    }
}
</style>

<style lang="scss">

.questions-bank-page{
    .v-btn{
        &.theme--light.v-btn--active:hover::before, &.theme--light.v-btn--active::before{
            opacity: 0.08!important;
        }
    }
}
</style>